import { React } from 'Imports';
import { ConfigService } from '$State/ConfigFreezerService';
import { MissingFleet } from '$Pages/MissingFleet/MissingFleet';
import { MultipleFleets } from '$Pages/MultipleFleets/MultipleFleets';
import { InactiveFleet } from '$Pages/InactiveFleet/InactiveFleet';
import { Error } from '$Pages/Error/Error';
export interface FleetValidationError {
    title: string;
    element: React.ReactElement;
}
export const getFleetValidationError = (): FleetValidationError | null => {
    if (ConfigService.isFleetIdValid()) {
        return null;
    }
    if (ConfigService.isFleetIdErrorMissing()) {
        return { title: 'Missing Fleet', element: <MissingFleet /> };
    }
    if (ConfigService.isFleetIdErrorMultiple()) {
        return { title: 'Multiple Fleets', element: <MultipleFleets /> };
    }
    if (ConfigService.isFleetIdErrorInactive()) {
        return { title: 'Inactive Fleet', element: <InactiveFleet /> };
    }
    return { title: 'Error', element: <Error /> };
};
